require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-size-classes-with-xcode-6-one-storyboard-for-all-sizes.json") })
        }
      }, "path---blog-size-classes-with-xcode-6-one-storyboard-for-all-sizes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-size-classes-with-xcode-6-one-storyboard-for-all-sizes!./.cache/json/blog-size-classes-with-xcode-6-one-storyboard-for-all-sizes.json
// module id = 1067
// module chunks = 231608221292675